import AddManageGroupMembersModal from 'components/group-setting/modals/AddManageGroupMembersModal';

function AddManageGroupMembers({
  companyMembers,
  group,
  onUpdateGroupSuccess,
  openModal,
  setOpenModal
}) {
  return (
    <>
      <span className="text-primary cursor-pointer flex items-center gap-1">
        <span className="text-xl">+</span>
        <span onClick={() => setOpenModal(true)} className="underline">
          Add/Manage Members
        </span>
      </span>
      <AddManageGroupMembersModal
        group={group}
        companyMembers={companyMembers}
        open={openModal}
        onClose={() => setOpenModal(false)}
        onUpdateGroupSuccess={onUpdateGroupSuccess}
      />
    </>
  );
}

export default AddManageGroupMembers;
